import { render, staticRenderFns } from "./SwitchProp.vue?vue&type=template&id=4531f102&"
import script from "./SwitchProp.vue?vue&type=script&lang=js&"
export * from "./SwitchProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports